import { useEffect } from "react";

/**
 * Updates document <title>, meta description, og:* and JSON-LD per page state.
 * Pure side-effect — no DOM render.
 */
function setMeta(name, content, attr = "name") {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setLink(rel, href) {
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export default function SeoHead({ title, description, canonicalPath, ogImage }) {
    useEffect(() => {
        // Canonical always points to the production domain (intentional for SEO — Google must
        // see one canonical regardless of preview/staging URLs). Override via REACT_APP_SITE_URL.
        const SITE_URL = process.env.REACT_APP_SITE_URL || "https://vatcalc.eu";

        if (title) document.title = title;
        if (description) {
            setMeta("description", description);
            setMeta("og:description", description, "property");
            setMeta("twitter:description", description);
        }
        if (title) {
            setMeta("og:title", title, "property");
            setMeta("twitter:title", title);
        }
        if (canonicalPath) {
            const url = `${SITE_URL}${canonicalPath}`;
            setLink("canonical", url);
            setMeta("og:url", url, "property");
        }
        if (ogImage) {
            setMeta("og:image", ogImage, "property");
            setMeta("twitter:image", ogImage);
            setMeta("twitter:card", "summary_large_image");
        }
    }, [title, description, canonicalPath, ogImage]);

    return null;
}
